import React from "react";
import styled, { css } from "styled-components";
import {
    flexCenter,
    flexColumn,
    transitionMixin,
    marginToChildren,
} from "./../mixins";

const invertedStyles = (isInverted) =>
    isInverted
        ? css`
              flex-direction: row-reverse;
          `
        : "";

const Wrapper = styled.div`
    position: relative;
    margin: 25px 0;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    ${({ inverted }) => invertedStyles(inverted)};

    @media screen and (max-width: 830px) {
        ${flexCenter};
        ${flexColumn};
        margin: 0 0 25px;

        ${({ invertedOnMobile }) =>
            invertedOnMobile
                ? css`
                      flex-direction: column-reverse;
                  `
                : ""}
    }
`;

const Title = styled.h1`
    text-transform: uppercase;
    margin-bottom: 15px;

    @media screen and (max-width: 830px) {
        text-align: center;
        padding: 0 20px;
    }
`;

const LeftBox = styled.div`
    ${flexColumn};
    justify-content: flex-start;
    align-items: flex-start;
    width: 45%;
    height: 100%;
    @media screen and (max-width: 830px) {
        width: 100%;
        ${flexCenter};
        ${flexColumn};
    }
`;

const ImgContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;

    img {
        display: flex;
        align-self: flex-start;
        height: 100%;
        width: 100%;
        max-height: 400px;
        object-fit: cover;
        object-position: left top;
        ${transitionMixin("1s")};

        &:hover {
            transform: scale(1.05);
        }

        &.small {
            max-height: 350px;
        }
    }

    ${({ containImg }) =>
        containImg
            ? css`
                  & img {
                      object-fit: contain;
                      max-height: 500px;
                  }
              `
            : ""}

    ${({ centerImg }) =>
        centerImg
            ? css`
                  & img {
                      object-position: center center;
                      max-height: 500px;
                  }
              `
            : ""}

    @media screen and (max-width: 830px) {
        ${flexCenter};
        width: 80%;

        img {
            width: auto;
            max-width: 100%;
            max-height: 600px;
            object-position: center center;
        }
    }
`;

const TextWrapper = styled.div`
    width: 50%;
    padding: 50px 20px 0;
    margin: 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    ${marginToChildren()};

    p {
        line-height: 150%;
    }

    & > ul {
        line-height: 380%;
        padding-left: 15px;
    }

    .uppercase {
        text-transform: uppercase;
    }

    @media screen and (max-width: 830px) {
        width: 90%;
    }
`;

const getFloatingStyles = (dir) => {
    if (dir === "left") {
        return css`
            left: -60px;
            transform: translateY(-50%) rotate(-90deg);
        `;
    } else if (dir === "right") {
        return css`
            right: -60px;
            transform: translateY(-50%) rotate(90deg);
        `;
    }
};

const FloatingTitle = styled.p`
    position: absolute;
    top: 50%;
    ${({ dir }) => getFloatingStyles(dir)}
    padding-bottom: 4px;
    color: #000;
    font-family: ${({ theme }) => theme.ff.Montserrat};
    font-size: ${({ theme }) => theme.fz.XXS};
    font-weight: ${({ theme }) => theme.fw.semiBold};
    text-transform: uppercase;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${({ theme }) => theme.colors.black};
        transform: translateX(-100%);
        ${transitionMixin()};
    }

    &:hover::before {
        transform: translateX(0%);
    }

    @media screen and (max-width: 1250px) {
        font-size: ${({ theme }) => theme.fz.XXXS};
    }

    @media screen and (max-width: 830px) {
        position: relative;
        top: unset !important;
        left: unset !important;
        right: unset !important;
        transform: none !important;
        margin: 0 0 15px;
        font-weight: ${({ theme }) => theme.fw.regular};
    }
`;

const BlockContainer = ({
    inverted = false,
    invertedOnMobile = false,
    smallIMG,
    centerImg = false,
    children,
    img,
    title,
    floatingTitle,
    containImg = false,
    id,
}) => (
    <Wrapper inverted={inverted} invertedOnMobile={invertedOnMobile} id={id}>
        <LeftBox>
            <Title>{title}</Title>
            <FloatingTitle dir={inverted ? "right" : "left"}>
                {floatingTitle}
            </FloatingTitle>
            <ImgContainer containImg={containImg} centerImg={centerImg}>
                <img
                    src={img}
                    alt="Dział magazynu"
                    className={smallIMG ? "small" : ""}
                />
            </ImgContainer>
        </LeftBox>
        <TextWrapper>{children}</TextWrapper>
    </Wrapper>
);
export default BlockContainer;
